import styled, { css } from 'styled-components'
import { size } from '../../../styles/GlobalVariables'
import { SizeMapItem } from '../../../sharedComponnets/Ads/Ad'

export const Container = styled.div<{
  side: 'left' | 'right'
  size?: SizeMapItem
}>`
  display: none;
  position: fixed;
  z-index: 1;

  ${props => {
    switch (props.side) {
      case 'left':
        return css`
          left: 0;
        `
      case 'right':
        return css`
          right: 0;
        `
    }
  }};

  @media (min-width: ${props => props.size?.screen[0] || size.small}px) {
    display: block;
  }
`
